const Live = (props) => {
    return <svg width="48" height="48" className={props.className} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="4" y="4" width="40" height="40" rx="20" fill="#FA5000" />
        <circle cx="20.625" cy="22.125" r="1.125" fill="white" />
        <path d="M16.7659 21.7643C16.8477 20.4986 17.7818 17.9738 20.8646 18.0002C23.9475 18.0266 24.8583 20.5206 24.9283 21.7643M15.75 22.8869V28.2689H19.3583M20.8646 25.0661V28.2689M23.2818 24.1086L24.9283 28.2689L26.8201 22.8869M32.25 23.2831H28.7468V25.776M32.25 28.2689H28.7468V25.776M28.7468 25.776H31.7596" stroke="white" strokeLinecap="round" />
        <rect x="4" y="4" width="40" height="40" rx="20" stroke="#FDAF8A" strokeWidth="8" />
    </svg>
}

export default Live;